import React from 'react';
import { motion } from 'framer-motion';
interface NeonButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function NeonButton({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: NeonButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 font-bold text-sm uppercase tracking-wider transition-all duration-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black';
  const variants = {
    primary: 'bg-[#FF6B35] text-black hover:bg-[#ff8559] hover:shadow-[0_0_20px_rgba(255,107,53,0.6)] focus:ring-[#FF6B35]',
    secondary: 'bg-transparent border border-[#FF6B35] text-[#FF6B35] hover:bg-[#FF6B35]/10 hover:shadow-[0_0_15px_rgba(255,107,53,0.3)] focus:ring-[#FF6B35]'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-249">
      {children}
    </motion.button>;
}